import type { NavigateFunction } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';

/**
 * Mở công việc dm_taskid TVNT (WBS/FBS) từ thông báo.
 */
export async function navigateToTuvanNhathauDmTask(
  navigate: NavigateFunction,
  taskId: number
): Promise<void> {
  try {
    const res = await axiosInstance.get(`/tuvan-nhathau/dm-taskids/${taskId}`);
    const d = res.data?.data;
    if (res.data?.code === 0 && d?.project_id != null) {
      const linkType = String(d.link_type || '').toUpperCase();
      const route = linkType === 'WBS' ? '/tuvan_nhathau/wbs' : '/tuvan_nhathau/fbs';
      navigate(route, {
        state: { navigateToTaskId: taskId, navigateToProjectId: d.project_id },
      });
      return;
    }
  } catch {
    /* ignore */
  }
  navigate('/tuvan_nhathau/fbs');
}
